const sidebarReducer = (state = 'responsive', { type, sidebarShow }) => {
  switch (type) {
    case 'set':
      return sidebarShow
    default:
      return state
  }
}
export default sidebarReducer
